import { Component, Input, OnInit } from '@angular/core';
import { Validators } from '@angular/forms';

import { BaseInput } from '@shared/forms/components/base-input/base-input.component';
import { VatinValidators } from '@shared/forms/validators/validators-vatin';

@Component({
    selector: 'input-nif',
    templateUrl: './input-nif.component.html',
})
export class InputNifComponent extends BaseInput implements OnInit {
    @Input() public company: boolean;

    @Input() public required: boolean;

    private readonly config: Record<string, Record<string, boolean>> = {
        TR: {
            companyDif: true,
        },
        default: {
            companyDif: false,
        },
    };

    private readonly errorTextConfig: Record<string, Record<string, string>> = {
        TW: {
            errorText: 'dev.messageError.NifTw',
        },
        default: {
            errorText: 'dev.forms.error',
        },
    };

    public errorMessageList: Record<string, string>;

    public ngOnInit(): void {
        // eslint-disable-next-line max-len
        const companyDif = this.config[this.countryCode] ? this.config[this.countryCode]?.companyDif : this.config.default.companyDif;

        this.errorMessageList = {
            required: 'dev.forms.required',
            pattern: this.errorTextConfig[this.countryCode]?.errorText || this.errorTextConfig.default.errorText,
            patternBack: 'dev.forms.nif.invalid',
        };

        this.setFormControls([
            {
                name: 'nif',
                validations: {
                    // Por ahora es necesario usar el validador 'Vatin' y no el 'Nif' como cabria esperar debido a como vienen los datos de la API
                    // Este input que llamamos Nif realmente esta actuando como Vatin, ya que debe permitir documento Nif y documentos Cif
                    // TODO ECOMDUTI-21013 mapear datos de la api para poder utilizar los validadores acorde al input, en este caso el validador Nif y no el Vatin

                    default: this.generateValidations(companyDif),
                },
                options: { updateOn: 'change' },
            },
        ]);
    }

    private generateValidations(companyDif): any[] {
        let validations = [];
        if (this.required) {
            validations.push(Validators.required);
        }
        validations.push(VatinValidators.createValidator(this.countryCode, companyDif, this.company));

        return validations;
    }
}
